(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vv-milano-motion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vv-milano-motion')) {
    customElements.define('vv-milano-motion', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.epoch = (this.epoch || 0) + 1;
        this.abort = new AbortController();
        this.stage = this.querySelector('.vv-hm__stage');
        this.canvas = this.querySelector('canvas');
        this.context = this.canvas.getContext('2d', { alpha: false });
        this.chapters = [...this.querySelectorAll('[data-chapter]')];
        this.steps = [...this.querySelectorAll('[data-step]')];
        this.counter = this.querySelector('[data-counter]');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.cache = new Map();
        this.pending = new Set();
        this.failed = new Set();
        this.attempts = new Map();
        this.retryTimers = new Set();
        this.preloaded = new Set();
        this.preloadLinks = new Map();
        this.activeChapter = 0;
        this.progress = 0;
        this.total = Math.max(1, Number(this.dataset.frames) || 360);
        this.displayProgress = null;
        this.lastTime = 0;
        this.drawn = -1;
        this.frameRequest = 0;
        this.config = JSON.parse(this.querySelector('[data-motion-config]').textContent);
        this.config.atlases = this.config.atlases.filter(atlas => atlas.desktop);
        this.querySelector('[data-reviews-link]')?.addEventListener('click', event => {
          const reviews = document.querySelector('[id$="__avis_L6RMKm"]') || document.querySelector('[id*="__avis_"]');
          if (!reviews) return;
          event.preventDefault();
          reviews.id = reviews.id || 'avis-clients';
          reviews.scrollIntoView({ behavior: this.reduced.matches ? 'auto' : 'smooth', block: 'start' });
        }, { signal: this.abort.signal });
        this.steps.forEach(button => button.addEventListener('click', () => {
          const n = Number(button.dataset.step);
          if (this.hasAttribute('data-enhanced')) {
            const target = this.top + this.travel * (n === 0 ? 0 : (n + .3) / 6);
            window.scrollTo({ top: target, behavior: this.reduced.matches ? 'instant' : 'smooth' });
          } else this.showChapter(n);
        }, { signal: this.abort.signal }));
        this.reduced.addEventListener('change', () => this.mode(), { signal: this.abort.signal });
        this.mobile.addEventListener('change', () => {
          this.epoch++;
          this.cache.clear(); this.pending.clear(); this.failed.clear(); this.attempts.clear(); this.drawn = -1;
          this.retryTimers.forEach(clearTimeout); this.retryTimers.clear(); this.clearPreloads(); this.preloaded.clear(); this.displayProgress = null; this.lastTime = 0;
          this.removeAttribute('data-painted'); this.mode();
        }, { signal: this.abort.signal });
        this.mode();
      }
      mode() {
        if (this.reduced.matches || navigator.connection?.saveData || !this.context || !this.config.atlases.length) {
          this.removeAttribute('data-enhanced');
          this.removeAttribute('data-painted');
          this.observer?.disconnect();
          this.clearPreloads();
          return;
        }
        this.style.setProperty('--hm-travel', `${Math.max(200, Number(this.dataset.sequenceHeight) || 520)}svh`);
        this.setAttribute('data-enhanced', '');
        if (!this.bound) {
          this.bound = true;
          window.addEventListener('scroll', () => this.queue(), { passive: true, signal: this.abort.signal });
          window.addEventListener('resize', () => { this.measure(); this.drawn = -1; this.queue(); }, { passive: true, signal: this.abort.signal });
          window.addEventListener('pageshow', () => { this.measure(); this.queue(); }, { signal: this.abort.signal });
          this.observer = new ResizeObserver(() => { this.measure(); this.drawn = -1; this.queue(); });
        }
        this.observer.observe(this.stage);
        this.measure(); this.load(0); this.queue();
        clearTimeout(this.startupTimer);
        this.startupTimer = setTimeout(() => {
          if (!this.hasAttribute('data-painted')) this.removeAttribute('data-enhanced');
        }, 12000);
      }
      measure() {
        this.top = window.scrollY + this.getBoundingClientRect().top;
        this.travel = Math.max(1, this.offsetHeight - this.stage.offsetHeight);
        const visual = this.querySelector('.vv-hm__visual');
        this.w = visual.clientWidth;
        this.h = visual.clientHeight;
        const scale = Math.min(window.devicePixelRatio || 1, this.mobile.matches ? 1.5 : 2);
        const w = Math.round(this.w * scale), h = Math.round(this.h * scale);
        if (this.canvas.width !== w || this.canvas.height !== h) { this.canvas.width = w; this.canvas.height = h; }
        this.context?.setTransform(scale, 0, 0, scale, 0, 0);
      }
      queue() {
        if (this.frameRequest || !this.hasAttribute('data-enhanced')) return;
        this.frameRequest = requestAnimationFrame(time => { this.frameRequest = 0; this.render(time); });
      }
      showChapter(n) {
        n = Math.max(0, Math.min(5, n));
        if (n === this.activeChapter) return;
        this.activeChapter = n;
        this.dataset.activeChapter = n;
        this.chapters.forEach((chapter, i) => { chapter.hidden = i !== n; chapter.classList.toggle('is-active', i === n); });
        this.steps.forEach((button, i) => { button.classList.toggle('is-current', i === n); if (i === n) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current'); });
        this.counter.textContent = String(n + 1).padStart(2, '0');
        this.style.setProperty('--hm-accent', n === 1 || n === 2 || n === 5 ? '#3d7f90' : '#507f7a');
      }
      render(time) {
        if (!this.hasAttribute('data-enhanced')) return;
        const target = Math.max(0, Math.min(1, (window.scrollY - this.top) / this.travel));
        const dt = this.lastTime ? Math.min(34, Math.max(1, time - this.lastTime)) : 16.7;
        this.lastTime = time;
        const current = this.displayProgress === null ? target : this.displayProgress;
        let p = current + (target - current) * (1 - Math.exp(-dt / 230));
        if (Math.abs(target - p) < .00003) p = target;
        const frame = p * (this.total - 1), index = Math.floor(frame), next = Math.min(this.total - 1, index + 1);
        const sheet = Math.floor(index / 16), nextSheet = Math.floor(next / 16), targetSheet = Math.floor(target * (this.total - 1) / 16);
        const direction = target < current ? -1 : 1;
        this.load(sheet); this.load(nextSheet); this.load(sheet - 1); this.load(sheet + 1); this.load(sheet + direction * 2); this.load(targetSheet);
        if (this.failed.has(sheet)) { this.removeAttribute('data-enhanced'); this.removeAttribute('data-painted'); return; }
        const img = this.cache.get(sheet), nextImg = this.cache.get(nextSheet);
        if (img) {
          this.displayProgress = p;
          this.progress = p;
          this.style.setProperty('--hm-progress', p.toFixed(4));
          this.showChapter(Math.min(5, Math.floor(p * 6)));
          const sw = img.naturalWidth / 4, sh = img.naturalHeight / 4;
          const dw = this.w * (this.mobile.matches ? 1.55 : .82), dh = dw * sh / sw;
          const dx = this.w * (this.mobile.matches ? .5 : .7) - dw * .55;
          const blend = nextImg && next !== index ? frame - index : 0;
          this.context.globalAlpha = 1;
          this.context.fillStyle = '#f7f8f9'; this.context.fillRect(0, 0, this.w, this.h);
          this.context.drawImage(img, (index % 4) * sw, Math.floor((index % 16) / 4) * sh, sw, sh, dx, (this.h - dh) / 2, dw, dh);
          if (blend > .001) {
            this.context.globalAlpha = blend;
            const nw = nextImg.naturalWidth / 4, nh = nextImg.naturalHeight / 4;
            this.context.drawImage(nextImg, (next % 4) * nw, Math.floor((next % 16) / 4) * nh, nw, nh, dx, (this.h - dh) / 2, dw, dh);
            this.context.globalAlpha = 1;
          }
          const dy = (this.h - dh) / 2;
          const fade = this.context.createLinearGradient(0, dy, 0, dy + dh);
          fade.addColorStop(0, '#f7f8f9');
          fade.addColorStop(.12, 'rgba(247,248,249,0)');
          fade.addColorStop(.88, 'rgba(247,248,249,0)');
          fade.addColorStop(1, '#f7f8f9');
          this.context.fillStyle = fade;
          this.context.fillRect(dx, dy, dw, dh);
          this.drawn = index; this.setAttribute('data-painted', '');
          this.dataset.motionFrame = String(index);
          this.prime(targetSheet);
          if (Math.abs(target - p) > .00003) this.queue();
        }
        for (const [key] of this.cache) if (Math.abs(key - sheet) > 2 && key !== targetSheet) this.cache.delete(key);
      }
      prime(target = 0) {
        if (!this.isConnected || !this.hasAttribute('data-enhanced')) return;
        const candidates = this.config.atlases.map((_, i) => i).filter(i => !this.preloaded.has(i)).sort((a, b) => Math.abs(a - target) - Math.abs(b - target));
        while (this.preloadLinks.size < 3 && candidates.length) {
          const index = candidates.shift();
          this.preloaded.add(index);
          if (this.cache.has(index) || this.pending.has(index)) continue;
          const source = this.config.atlases[index];
          const link = document.createElement('link');
          link.rel = 'preload'; link.as = 'image'; link.fetchPriority = 'low';
          link.href = this.mobile.matches && source.mobile ? source.mobile : source.desktop;
          const epoch = this.epoch;
          const finish = () => {
            if (epoch !== this.epoch) return;
            clearTimeout(this.preloadLinks.get(link));
            this.preloadLinks.delete(link); link.remove();
            this.prime(Math.floor((this.progress || 0) * (this.total - 1) / 16));
          };
          link.onload = finish; link.onerror = finish;
          this.preloadLinks.set(link, setTimeout(finish, 15000));
          document.head.appendChild(link);
        }
      }
      clearPreloads() {
        this.preloadLinks?.forEach((timer, link) => {
          clearTimeout(timer); link.onload = null; link.onerror = null; link.remove();
        });
        this.preloadLinks?.clear();
      }
      load(index) {
        if (index < 0 || index >= this.config.atlases.length || this.cache.has(index) || this.pending.has(index) || this.failed.has(index)) return;
        this.pending.add(index);
        this.attempts.set(index, (this.attempts.get(index) || 0) + 1);
        const epoch = this.epoch;
        const image = new Image();
        image.decoding = 'async';
        const source = this.config.atlases[index];
        image.onload = () => {
          if (!this.isConnected || epoch !== this.epoch) return;
          this.pending.delete(index);
          this.cache.set(index, image); this.queue();
        };
        image.onerror = () => {
          if (!this.isConnected || epoch !== this.epoch) return;
          this.pending.delete(index);
          if (this.attempts.get(index) < 3) {
            this.pending.add(index);
            const timer = setTimeout(() => {
              this.retryTimers.delete(timer);
              this.pending.delete(index);
              if (this.isConnected && epoch === this.epoch) { this.load(index); this.queue(); }
            }, 600 * this.attempts.get(index));
            this.retryTimers.add(timer);
          } else { this.failed.add(index); this.queue(); }
        };
        image.src = this.mobile.matches && source.mobile ? source.mobile : source.desktop;
      }
      disconnectedCallback() {
        this.epoch++;
        clearTimeout(this.startupTimer);
        this.retryTimers?.forEach(clearTimeout);
        this.clearPreloads();
        this.abort?.abort(); this.observer?.disconnect();
        if (this.frameRequest) cancelAnimationFrame(this.frameRequest);
        this.cache?.clear(); this.started = false; this.bound = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
